
import axiosClient from "../../../../../api/axiosClient";

// ============================================================================
// Service: Procurement Lifecycle Report API
// ============================================================================

export const fetchProcurementLifecycleReport = async ({
  source_type,
  source_id,
}) => {
  const params = new URLSearchParams({
    source_type,
    source_id: String(source_id),
  }).toString();

  const response = await axiosClient.get(
    `/api/ppe/reports/lifecycle/procurement?${params}`
  );

  return response.data;
};

// ============================================================================
// Search Orders for Procurement Lifecycle Report dropdown
// ============================================================================

export const searchProcurementOrders = async (keyword = "") => {
  const response = await axiosClient.get("/api/ipe/orders", {
    params: { search: keyword },
  });

  return response.data?.data?.items || [];
};
